// REDUX
import {
    types
} from './types';

// FIREBASE
import firebase from '../firebase/firebase';
const db = firebase.database();

// UTILS
import {
    toArray
} from 'utils/lodashUtils';
import moment from 'moment-timezone';

import {
    getUserTimezone,
    convertDateTimeToUserTimezone,
    getCompanyTimezone
} from '../utils/timezoneUtils';
import getSbmClient from '../utils/getSbmClient';

export const bookConsult = ({
    userId,
    serviceId,
    providerId,
    startDate,
    startTime,
    clientData = null, // TODO: DELETE IF NOT BEING USED IN CLOUD FUNCTION - SET TO NULL TO AVOID ERRORS WHEN NOT PRESENT
    additionalData,
    reason,
    clientId,
    cb, // TODO: DELETE IF NOT BEING USED
    providerKey,
    serviceKey,
    activePeriodKey,
    bookingFromCompanyDashboard = null
}) => async dispatch => {
    console.log(`%c NOW RUNNING BOOK CONSULT`, 'color: greenyellow');
    var tzid = moment.tz.guess();
    console.log('ACTIVE PERIOD KEY @ BookConsult', activePeriodKey);

    const bookingData = {
        serviceId,
        providerId,
        startDate,
        startTime,
        clientData,
        additionalData,
        clientId,
        userTimezone: tzid,
        providerKey,
        serviceKey,
        activePeriodKey,
    };

    const sbmClient = getSbmClient();

    // const startDateTime = moment(`${startDate} ${startTime}`, 'YYYY-MM-DD HH:mm:ss');

    // const cynoTime = startDateTime.tz(getCompanyTimezone(sbmClient));
    // const companyStartDateTime = cynoTime.format('YYYY-MM-DD HH:mm:ss');

    // Determine Offset in Seconds for SBM
    // const userTime = startDateTime.tz(tzid);
    // const localOffset = userTime.utcOffset();

    // const utcServiceStartMoment = moment.utc(cynoTime);
    // const utcServiceStartTimestamp = moment.utc(cynoTime).format('x');

    // Determine time offset
    // const companyOffset = cynoTime.utcOffset();
    // const diffInMinutes = localOffset - companyOffset;
    // const diffInSeconds = diffInMinutes * 60;

    // const userStartMoment = convertDateTimeToUserTimezone(companyStartDateTime, tzid, sbmClient.getCompanyTimezoneOffset().timezone);
    // const userStartDateTime = userStartMoment.format('YYYY-MM-DD HH:mm:ss');
    // console.log('USER DATE TIME');
    // const userStartDateTime = userTime.format('YYYY-MM-DD HH:mm:ss');
    // console.log(`%c${JSON.stringify(diffInSeconds)}`,'color: aqua');

    let updates = {};
    let bookingKey = db.ref().push().key;

    return new Promise((resolve, reject) => {
        updates[`/bookings/${bookingKey}/serviceSbmId`] = serviceId;
        updates[`/bookings/${bookingKey}/serviceKey`] = serviceKey;
        updates[`/bookings/${bookingKey}/providerSbmId`] = providerId;
        updates[`/bookings/${bookingKey}/providerUid`] = providerKey;
        updates[`/bookings/${bookingKey}/startDate`] = startDate;
        updates[`/bookings/${bookingKey}/startTime`] = startTime;
        updates[`/bookings/${bookingKey}/clientData`] = clientData;
        updates[`/bookings/${bookingKey}/additionalData`] = additionalData;
        updates[`/bookings/${bookingKey}/reason`] = reason;
        updates[`/bookings/${bookingKey}/clientSbmId`] = clientId;
        updates[`/bookings/${bookingKey}/userTimezone`] = tzid;
        updates[`/bookings/${bookingKey}/clientUid`] = userId;
        updates[`/bookings/${bookingKey}/activePeriodKey`] = activePeriodKey;
        updates[`/bookings/${bookingKey}/key`] = bookingKey;
        updates[`/bookings/${bookingKey}/isCompanyInitiatedBooking`] = bookingFromCompanyDashboard; // NOT BEING USED BUT COULD BE USEFUL FOR QUERYING IN THE FUTURE

        // updates[`/bookings/${userId}/${bookingKey}/clientTimezone/clientTimeOffset`] = diffInSeconds;
        // updates[`/bookings/${userId}/${bookingKey}/clientTimezone/userStartDateTime`] = userStartDateTime;
        // updates[`clients/${userId}/services/${serviceKey}/utcServiceStartTimestamp`] = utcServiceStartTimestamp;
        // updates[`/bookings/${userId}/${bookingKey}/companyStartMoment`] = cynoTime;
        // updates[`/bookings/${userId}/${bookingKey}/userStartMoment`] = userTime;

        // console.log('SAVING BOOKING INFO TO DB...');
        db.ref().update(updates)
            .then((result) => {
                // console.log('Booking data sent to DB.');

                console.log('Listening for booking confirmation...', bookingKey);

                // Listen for booking confirmation to complete and when it does resolve with booking data.
                const confirmationRef = db.ref(`/bookings/${bookingKey}`);
                confirmationRef.off();
                confirmationRef.on('value', snap => {
                    // console.log('CHANGE IN BOOKINGS NOTED');

                    if (snap.val().bookingStatus === 'success' /* assumes that if it was a success we have confirmation data */ ) {
                        const confirmationData = snap.val().confirmationData;
                        console.log('BOOKING CONFIRMED', snap.val());
                        if (!bookingFromCompanyDashboard) {
                            dispatch(confirmNewBooking());
                            dispatch(loadUpcomingDbBookings({
                                userId,
                                serviceId: serviceKey,
                                clientUid: userId,
                                userType: 'client'
                            }));
                            resolve(confirmationRef, bookingData, snap.val().confirmationData); // UNSURE IF THIS RETURNS ALL THREE VALUES - LEAVING SO AS NOT TO BREAK ANYTHING ELSE
                        } else if (bookingFromCompanyDashboard) {
                            resolve({
                                confirmationRef,
                                bookingData,
                                confirmationData
                            })
                        }
                        // can maybe loadNewDbBookings here using dispatch??
                    }

                    if (snap.val().bookingStatus === 'failed') {
                        console.log('BOOKING FAILED', snap.val());
                        if (!bookingFromCompanyDashboard) {
                            dispatch(confirmNewBooking()); // Turns off spinner now that the booking is done.
                            dispatch(loadUpcomingDbBookings({
                                userId,
                                serviceId: serviceKey,
                                clientUid: userId,
                                userType: 'client'
                            })); // shows all new bookings including failed ones
                            resolve(confirmationRef, bookingData, null); // UNSURE IF THIS RETURNS ALL THREE VALUES - LEAVING SO AS NOT TO BREAK ANYTHING ELSE
                        } else if (bookingFromCompanyDashboard) {
                            resolve({
                                confirmationRef,
                                bookingData,
                                confirmationData: null
                            })
                        }
                        // can maybe loadNewDbBookings here using dispatch??
                    }
                }, (error) => {
                    console.log('FIREBASE ERROR', error);
                })

            })
            .catch((e) => {
                console.log('ERROR IN BOOKING', e);
                // MIGHT WANT TO CLEAN UP ANY MESS HERE - IDEALLY PREVENT THE MESS
                reject(e);
            });
    });
}

export const rebookConsult = (booking, bookingKey, clientUid) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        console.log('BOOKING AND BOOKING KEY', booking, bookingKey)


        let updates = {};

        updates[`bookings/${bookingKey}/startDate`] = booking.date;
        updates[`bookings/${bookingKey}/startTime`] = booking.time;
        updates[`bookings/${bookingKey}/clientTimezone`] = moment.tz.guess();
        updates[`bookings/${bookingKey}/bookingStatus`] = 'rebooking';

        try {
            db.ref().update(updates)
                .then((res) => {
                    // console.log('updates to bookings sent');
                    // LISTEN FOR CHANGES
                    console.log('LISTENING FOR CHANGES TO BOOKING STATUS...');

                    db.ref(`bookings/${bookingKey}/bookingStatus`).on('value', snap => {
                        if (snap.val() === 'success') {
                            resolve('success');
                        }
                        if (snap.val() === 'failed') {
                            resolve('failed');
                        }
                    })
                })
                .catch(console.log); // THIS IS DENIED EITHER NEED TO CHANGE THE RULES OR GET ALL THE PROPS AND SET THEM ALL AGAIN IN ONE SET OP
        } catch (e) {
            console.log('Error sending updates to booking:', e)
        }
    });
}

export const saveTempBookingData = ({
    bookingData
}) => async dispatch => {
    dispatch({
        type: types.SAVE_TEMP_BOOKING_DATA,
        payload: bookingData,
    });
};

export const saveCurrentBookingClientData = ({
    selectedClient
}) => async dispatch => {
    dispatch({
        type: types.SAVE_CURRENT_BOOKING_CLIENT,
        payload: selectedClient
    })
}

export const saveCurrentSelectedServiceData = ({
    selectedService
}) => async dispatch => {
    dispatch({
        type: types.SAVE_CURRENT_SELECTED_SERVICE,
        payload: selectedService
    })
}

export const getCurrentBookingClientData = ({
    tempNewClientDataKey,
    companyId
}) => async dispatch => {
    return new Promise((resolve, reject) => {
        let tempNewClientDataRef = db.ref(`tempNewClientData/${tempNewClientDataKey}`);
        tempNewClientDataRef.on('value', tempNewClientDataSnap => {
            let tempNewClientData = tempNewClientDataSnap.val();
            if (tempNewClientData) {
                tempNewClientDataRef.off();
                db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                    type: 'success',
                    title: 'Success',
                    message: 'Account successfully added'
                });
                dispatch({
                    type: types.SAVE_CURRENT_BOOKING_CLIENT,
                    payload: tempNewClientData
                })
                tempNewClientDataRef.set(null);
                resolve(true);
            }
        }, (err) => console.log(err))
    })
}

export const getActivePeriodKey = ({
    servicePeriod,
    clientId,
    serviceId,
    providerId,
    firstName,
    lastName
}) => async dispatch => {
    return new Promise((resolve, reject) => {
        let paymentId = db.ref().push().key;
        let tempServicePeriodData = {
            servicePeriod,
            clientId,
            serviceId,
            providerId,
            firstName,
            lastName,
            paymentId
        };
        let tempServicePeriodDataRef = db.ref(`/clients/${providerId}/tempServicePeriodData`);
        tempServicePeriodDataRef.set(tempServicePeriodData, (err) => {
            if (err) {
                console.log(err)
            }
        });
        tempServicePeriodDataRef.on('value', activePeriodKeySnap => {
            let activePeriodKey = activePeriodKeySnap.val();
            // CLOUD FUNCTION RECEIVES AN OBJECT BUT OVERWRITES WITH THE KEY WE WANT
            if (typeof activePeriodKey !== 'object') {
                tempServicePeriodDataRef.off();
                resolve(activePeriodKey);
            }
        }, (err) => console.log(err));
    })
}

const convertBookingsToUserTimezone = (bookings, userTimezone) => {
    return bookings.map((booking, index) => {
        booking.userDateTime = convertDateTimeToUserTimezone(`${booking.companyStartDateTime}`, userTimezone, booking.companyTimezone);
        return booking;
    });
}

const filterBookingsByCompletionStatus = ({
    bookings,
    isCompleted
}) => {
    try {
        const filteredBookings = bookings.filter(booking => {
            const {
                userDateTime,
                confirmationData
            } = booking;
            if (confirmationData) {
                const endDateTime = moment(confirmationData.end_date_time, 'YYYY-MM-DD HH:mm:ss');
                const userEndDateTime = convertDateTimeToUserTimezone(`${confirmationData.end_date_time}`, booking.userTimezone, booking.companyTimezone);
                if (isCompleted) {
                    return userEndDateTime.isBefore(); // get bookings that are before now
                } else {
                    return userEndDateTime.isAfter(); // get bookings that are after now
                }
            } else {
                const endDateTime = null;
                const userEndDateTime = null;
                if (booking.hidden) { // THIS IS A QUICK FIX TO MANUALLY HIDE FAILED BOOKING THAT OCCURRED DUE TO A BUG - SAVES MUCH TIME DELTEING DB ENTRIES SO WE CAN FOCUS ON THE SPRINT AT HAND - IN THE FUTURE THE BEST WAY TO GET RID OF THESE IS HAVING REBOOK AND CANCEL OPTIONS
                    return false;
                }
                return true; // return failed booking as new
            }
            return false;
        });
        // console.log(filteredBookings, 'filtered bookings');
        return filteredBookings;
    } catch (e) {
        console.log('Error at filter bookings by completion status:', e);
    }
}

const returnAllBookings = (bookings, dispatch, userTimezone) => {
    const bookingsInUserTimezone = convertBookingsToUserTimezone(bookings, userTimezone);
    dispatch({
        type: types.GET_ALL_CLIENT_BOOKINGS,
        payload: bookingsInUserTimezone
    });
    // console.log(bookingsInUserTimezone + ' bookings in user timezone');
}

const returnPastBookings = (bookings, dispatch, userTimezone) => {
    const bookingsInUserTimezone = convertBookingsToUserTimezone(bookings, userTimezone);
    const pastBookings = filterBookingsByCompletionStatus({
        bookings: bookingsInUserTimezone,
        isCompleted: true // ONLY SET AS COMPLETED 1 hr after start or by end time not start time
    });

    dispatch({
        type: types.GET_PAST_CLIENT_BOOKINGS,
        payload: pastBookings
    });
}

const dispatchFutureBookings = ({
    bookings,
    dispatch,
    userTimezone
}) => {
    if (!bookings || !dispatch || !userTimezone) {
        console.log('Critical Error: missing argument in dispatchFutureBookings');
    }
    // GET USER TIMEZONE - GET COMPANY TIMEZONE AND CONVERT
    try {
        const bookingsInUserTimezone = convertBookingsToUserTimezone(bookings, userTimezone);
        const futureBookings = filterBookingsByCompletionStatus({
            bookings: bookingsInUserTimezone,
            isCompleted: false
        });
        // console.log('DISPATCHING FUTURE BOOKINGS @ dispatchFutureBookings', futureBookings);
        dispatch({
            type: types.GET_FUTURE_CLIENT_BOOKINGS,
            payload: futureBookings
        });
    } catch (e) {
        console.log('Error at dispatch future bookings:', e);
    }
}

const orderBookingQueryBy = (userType) => {
    if (userType === 'provider') {
        return 'providerUid';
    } else {
        return 'clientUid';
    }
}

export const loadUpcomingDbBookings = ({
    userId,
    serviceId,
    clientUid,
    userType
}) => dispatch => {
    if (userId && userType) {
        dispatch(clearBookings());
        // console.log('RUNNING LOAD UPCOMING BOOKINGS');

        let initialDataLoaded = false;
        const clientBookingsRef = db.ref(`bookings`);
        // console.log('ORDERING BY', orderBookingQueryBy(userType));

        const clientBookingsQuery = clientBookingsRef.orderByChild(orderBookingQueryBy(userType)).equalTo(userId);
        clientBookingsQuery.off();

        const handleClientBookings = (clientBookingsSnapshot, dataType) => {
            try {
                if (dataType === 'initial') {
                    initialDataLoaded = true;
                    // console.log('LOADING ALL EXISTING UPCOMING BOOKINGS FOR USER', clientBookingsSnapshot.val());
                }

                let bookings = [];
                clientBookingsSnapshot.forEach((bookingSnap) => {
                    const booking = bookingSnap.val();

                    // GET BOOKINGS FOR CLIENT SPECIFIC TO THE SERVICE
                    if (!clientUid && booking.serviceKey === serviceId) {
                        bookings.push(booking);
                    }
                    // GET BOOKINGS FOR PROVIDER SPECIFIC TO THIS CLIENT AND SERVICE
                    if (clientUid && booking.serviceKey === serviceId && booking.clientUid === clientUid) {
                        bookings.push(booking);
                    }
                })
                // console.log('CLIENT BOOKINGS FOR THIS SERVICE', bookings);

                dispatchFutureBookings({
                    bookings,
                    dispatch,
                    userTimezone: getUserTimezone(),
                });
            } catch (e) {
                console.log('Error at client bookings handler:', e);
            }
        }

        // console.log(userId, userType, 'USER TYPE AND ID unDEFINED?');

        clientBookingsQuery.once('value', (snap) => {
            handleClientBookings(snap, 'initial');
        }, (e) => {
            console.log('DATABASE ERROR', e);
        });

        clientBookingsQuery.on('child_added', (snap) => {
            if (initialDataLoaded) {
                console.log('NEW BOOKING DETECTED', snap.val());
                // AFTER THIS WE STILL NEED TO WAIT FOR CONFIRMATION BEFORE SHOWING CLIENT
                // IF CONFIRMATION FAILS WE NEED TO REBOOK

                // SHOW OLD BOOKINGS
                // dispatch(clearBookings());
                dispatchFutureBookings({
                    bookings: [snap.val()],
                    dispatch,
                    userTimezone: getUserTimezone(),
                });
            }
        }, (e) => {
            console.log('DATABASE ERROR (BOOKINGS LISTENER)', e);
        });
    } else {
        console.log('USER MUST BE LOGGED IN TO LOAD BOOKINGS')
    }
}

export const clearBookings = () => {
    return {
        type: types.CLEAR_ALL_BOOKINGS
    }
}

export const confirmNewBooking = () => {
    return {
        type: types.CONFIRM_NEW_BOOKING
    };
}

export const awaitNewBooking = () => {
    return {
        type: types.AWAIT_NEW_BOOKING
    };
}

export const getBookings = ({
    userId,
    past,
    future,
    serviceId,
    serviceSbmId,
    bookings: allClientBookings,
    clientUid
}) => dispatch => {
    // NOTE: THIS IS DEPRECATED AND NOT USED
    if (!allClientBookings) return null;
    const userTimezone = getUserTimezone();
    const bookingsRef = db.ref('/bookings');

    // if serviceId then get only for that service otherwise get all
    // console.log('SERVICE ID PASSED IN @ getBookings: ', serviceId);
    return new Promise(function (resolve, reject) {
        let bookings = [];
        // console.log('ALL CLIENT BOOKINGS', allClientBookings);

        allClientBookings.map(booking => {
            // console.log('BOOKING @ getBookings', booking);

            if (serviceId && !clientUid) {
                // If serviceId is specified get only the bookings for that service
                // console.log('BOOKING ID MATCH?', booking.serviceKey, serviceId);
                if (booking.serviceKey === serviceId) {
                    bookings.push(booking);
                }
            }
            // console.log('CLIENT', clientUid);

            if (clientUid && serviceId) {
                if (booking.clientUid === clientUid) {
                    bookings.push(booking);
                }
            }
        })

        if (past && !future) {
            resolve(); // trigger next function
            returnPastBookings(bookings, dispatch, userTimezone);
        }
        if (future && !past) {
            resolve(); // trigger next function
            dispatchFutureBookings({
                bookings,
                dispatch,
                userTimezone
            });
        }

        if (future && past) {
            resolve(); // trigger next function // pass the ref so that on can be turned off
            returnAllBookings(bookings, dispatch, userTimezone);
        }
    });
}

// Not being used right now - we are only rebooking
export const cancelBooking = (bookingKey, userId) => dispatch => {
    console.log('CANCELLING BOOKING');

    return new Promise((resolve, reject) => {
        // Send cancel to backend cloud function to cancel with SBM
        const bookingsRef = db.ref(`bookings/${bookingKey}`);
        bookingsRef.set('cancelling');
        // Wait for server to set value to cancelled then stop listening.
        bookingsRef.on('value', snap => {
            console.log('CANCELLED SUCCESSFULLY');
            const bookingStatus = snap.val().bookingStatus;
            if (bookingStatus === 'cancelled') {
                resolve();
                dispatch({
                    type: types.BOOKING_CANCEL_SUCCESS
                })
                // RESET BOOKINGS
                dispatch(clearBookings());
                dispatch(loadUpcomingDbBookings({
                    userId: userId,
                    serviceId: snap.val().serviceKey,
                    userType: 'client'
                }))
                bookingsRef.off();
            }
        }, e => console.log)
    });
}

export const setBookingProvider = (bookingProvider) => {
    return {
        type: types.SET_BOOKING_PROVIDER,
        payload: bookingProvider
    };
}

export const setBookingService = (bookingService) => {
    return {
        type: types.SET_BOOKING_SERVICE,
        payload: bookingService
    };
}

export const setBookingDetails = (bookingDetails) => {
    return {
        type: types.SET_BOOKING_DETAILS,
        payload: bookingDetails
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/booking-actions.js